export const authState = (state = false, action) => {
  // console.log(
  //   action.payload,
  //   "is payload of addFact",
  //   state,
  //   "is state of fact"
  // );
  switch (action.type) {
    case "LOGGEDIN":
      state = action.payload;
      return state;
    case "LOGGEDOUT":
      state = false;
      return state;
    default:
      return state;
  }
};
